import { Box, Flex, Image } from '@chakra-ui/react';
import _ from 'lodash';
import GridHeading from 'presentation/components/shared/grid/GridHeading';
import { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import FsLightbox from 'fslightbox-react';

interface Props {
  photos: RemoteFile[];
  chunkPhotosLength: number;
}

const EventDetailPhotos: FC<Props> = ({ photos, chunkPhotosLength }) => {
  const photoWidths = [
    [210, 227, 102, 175],
    [227, 102, 175, 210],
  ];
  const chunkPhotos = photos.slice(0, chunkPhotosLength);
  const chunkCount = 4;
  const chunks = _.chunk(chunkPhotos, chunkCount);

  const [selectedIndex, setSelectedIndex] = useState<number>(0);
  const [toggler, setToggler] = useState(false);

  const { t } = useTranslation();

  return (
    <>
      <GridHeading>{t('photosFromEvent')}</GridHeading>
      <Box borderRadius="16px" overflow="hidden">
        {chunks.map((chunk, chunkIndex) => {
          return (
            <Flex
              key={chunkIndex}
              mb={chunkIndex < chunks.length - 1 ? '2px' : 0}
            >
              {chunk.map((photo, photoIndex) => (
                <Box
                  key={photoIndex}
                  flex={photoWidths[chunkIndex % 2][photoIndex]}
                  mr={photoIndex < chunkCount - 1 ? '2px' : 0}
                >
                  <Image
                    src={photo.previewUrl ?? photo.url}
                    w="100%"
                    h="150px"
                    objectFit="cover"
                    onClick={() => {
                      setToggler(!toggler);
                      setSelectedIndex((chunkIndex * chunkCount) + photoIndex);
                    }}
                  />
                </Box>
              ))}
            </Flex>
          );
        })}
      </Box>
      <FsLightbox
        toggler={toggler}
        sources={photos.map((photo) => photo.url)}
        sourceIndex={selectedIndex}
        type="image"
        disableLocalStorage={false}
      />
    </>
  );
};

export default EventDetailPhotos;
